module.exports = __webpack_public_path__ + "img/header_img.756f15d8.png";